import { IGraphqlProduct } from '@bemer/base';
import { assign, Machine, StateSchema } from 'xstate';

interface IM0023Schema {
  states: {
    init: StateSchema;
  };
}

interface IM0023Context {
  allItems: IGraphqlProduct[];
  currentFilter: string;
  allFilters: string[];
  filteredItems: IGraphqlProduct[];
}

type TM0023Events =
  | { type: 'updateData'; allItems: IGraphqlProduct[] }
  | { type: 'setFilter'; filterValue: string };

const INITIAL_FILTER = 'all';
const MINIMUM_NUMBER_OF_FILTERS = 2;

const m0023Machine = Machine<IM0023Context, IM0023Schema, TM0023Events>(
  {
    id: 'm0023',
    initial: 'init',
    context: {
      allItems: [],
      allFilters: [],
      currentFilter: INITIAL_FILTER,
      filteredItems: [],
    },
    states: {
      init: {
        entry: ['getAllFilters'],
        on: {
          setFilter: {
            actions: ['setFilter', 'applyFilter'],
          },
          updateData: {
            actions: [
              'updateAllItems',
              'getAllFilters',
              'resetFilter',
              'applyFilter',
            ],
          },
        },
      },
    },
  },
  {
    actions: {
      getAllFilters: assign({
        allFilters: (context, _event) => {
          const filters = context.allItems
            .map((item) => item.productCategories)
            .flat()
            .map((item) => item.name);
          const uniqueFilters = [...new Set(filters)].sort();
          return uniqueFilters.length >= MINIMUM_NUMBER_OF_FILTERS
            ? uniqueFilters
            : [];
        },
      }),
      setFilter: assign({
        currentFilter: (context, event) =>
          event.type === 'setFilter'
            ? event.filterValue
            : context.currentFilter,
      }),
      resetFilter: assign({
        currentFilter: (_context, _event) => INITIAL_FILTER,
      }),
      applyFilter: assign({
        filteredItems: (context, _event) =>
          context.currentFilter === INITIAL_FILTER
            ? context.allItems
            : context.allItems.filter((item) =>
                item.productCategories.some(
                  (cat) => cat.name === context.currentFilter
                )
              ),
      }),
      updateAllItems: assign({
        allItems: (context, event) =>
          event.type === 'updateData' ? event.allItems : context.allItems,
      }),
    },
  }
);

export { m0023Machine, TM0023Events };
